import { render, staticRenderFns } from "./edit-radio.vue?vue&type=template&id=a82a7700&"
import script from "./edit-radio.vue?vue&type=script&lang=js&"
export * from "./edit-radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports